const $ff60e7647c4adb6c$export$bfcccf5e317befd3 = ()=>{
    const dropdown = document.querySelector('.dropdown');
    const dropdownTrigger = document.querySelector('.dropdown__trigger');
    const dropdownContent = document.querySelector('.dropdown__content');
    if (!dropdown || !dropdownTrigger || !dropdownContent) return;
    const closeDropdown = ()=>{
        dropdownTrigger.classList.remove('dropdown__trigger--active');
        dropdownContent.classList.remove('dropdown__content--active');
    };
    const toggleDropdown = ()=>{
        const isActive = dropdownTrigger.classList.toggle('dropdown__trigger--active');
        dropdownContent.classList.toggle('dropdown__content--active', isActive);
    };
    dropdownTrigger.addEventListener('click', toggleDropdown);
    document.addEventListener('click', (e)=>{
        const target = e.target.closest('.dropdown__item');
        if (target) closeDropdown();
    });
    document.addEventListener('click', (e)=>{
        if (dropdownTrigger.classList.contains('dropdown__trigger--active') && !dropdown.contains(e.target)) closeDropdown();
    });
    window.addEventListener('resize', ()=>{
        if (window.innerWidth < 1280 && dropdownTrigger.classList.contains('dropdown__trigger--active')) closeDropdown();
    });
};


const $689d83c62c3b09ab$export$c28495b2e70485f1 = ()=>{
    const triggerDropdown = document.querySelector('.dropdown__trigger');
    const dropdownLangList = document.querySelector('.dropdown__list');
    const langMenu = document.querySelector('.menu__lang');
    const langMenuList = langMenu.querySelector('.menu__list');
    const updateLangSelector = (selectedLang)=>{
        const prevActiveHeader = dropdownLangList?.querySelector('.dropdown__item--active');
        const prevActiveMenu = langMenuList?.querySelector('.menu__item--active');
        prevActiveHeader?.classList.remove('dropdown__item--active');
        prevActiveMenu?.classList.remove('menu__item--active');
        const newActiveHeader = dropdownLangList?.querySelector(`.dropdown__item[data-lang="${selectedLang}"]`);
        const newActiveMenu = langMenuList?.querySelector(`.menu__item[data-lang="${selectedLang}"]`);
        if (newActiveHeader) {
            triggerDropdown.textContent = selectedLang;
            newActiveHeader.classList.add('dropdown__item--active');
        }
        newActiveMenu?.classList.add('menu__item--active');
    };
    const handlLangListClick = (e)=>{
        const closestLi = e.target.closest('li');
        if (closestLi) {
            const selectedLang = closestLi.dataset.lang;
            updateLangSelector(selectedLang);
        }
    };
    dropdownLangList?.addEventListener('click', handlLangListClick);
    langMenuList?.addEventListener('click', handlLangListClick);
};


const $9463ba52c520f603$export$7120c31117304a49 = ()=>{
    const langButton = document.querySelector('.menu__btn--lang');
    const helpButton = document.querySelector('.menu__btn--help');
    const faqButton = document.querySelector('.menu__btn--faq');
    const langMenu = document.querySelector('.menu__lang');
    const helpMenu = document.querySelector('.menu__help');
    const faqMenu = document.querySelector('.menu__faq');
    const backButton = document.querySelector('.menu__back');
    const navMenu = document.querySelector('.menu__nav');
    const closeIcon = document.querySelector('.menu__link-close');
    const resetMenu = ()=>{
        langMenu.classList.add('hidden');
        helpMenu.classList.add('hidden');
        faqMenu.classList.add('hidden');
        navMenu.classList.remove('hidden');
        backButton.classList.add('hidden');
        closeIcon.classList.remove('hidden');
        closeIcon.style.order = '1';
    };
    window.addEventListener('DOMContentLoaded', resetMenu);
    langButton.addEventListener('click', function() {
        langMenu.classList.remove('hidden');
        navMenu.classList.add('hidden');
        closeIcon.classList.add('hidden');
        backButton.classList.remove('hidden');
        closeIcon.style.order = '2';
    });
    helpButton.addEventListener('click', function() {
        helpMenu.classList.remove('hidden');
        navMenu.classList.add('hidden');
        backButton.classList.remove('hidden');
        closeIcon.style.order = '2';
    });
    faqButton.addEventListener('click', function() {
        faqMenu.classList.remove('hidden');
        navMenu.classList.add('hidden');
        backButton.classList.remove('hidden');
        closeIcon.style.order = '2';
    });
    helpMenu.addEventListener('click', (e)=>{
        if (e.target.closest('a')) resetMenu();
    });
    faqMenu.addEventListener('click', (e)=>{
        if (e.target.closest('a')) resetMenu();
    });
    const languageButtons = langMenu.querySelectorAll('.nav__link.menu__link');
    languageButtons.forEach((button)=>{
        button.addEventListener('click', function() {
            resetMenu();
        });
    });
    backButton.addEventListener('click', function() {
        resetMenu();
    });
    closeIcon.addEventListener('click', function() {
        resetMenu();
    });
};


const $2f471956f63bc693$export$5cb4bf18b308e62f = ()=>{
    const faq = document.querySelector('.faq-module');
    const faqContent = document.querySelector('.faq-module__content');
    const closeFaqBtn = document.querySelector('.faq-module__close');
    const faqMoreBtn = document.querySelector('.faq-module__more');
    const openFaqBtns = document.querySelectorAll('.faq-module-btn');
    const resetAccordion = ()=>{
        [
            ...accordions
        ].forEach((accordion)=>{
            console.log(accordion);
            if (accordion.classList.contains('accordion--open')) accordion.classList.remove('accordion--open');
        });
    };
    const openFaq = ()=>{
        faq.classList.add('page__aside--active');
    };
    const closeFaq = ()=>{
        faq.classList.remove('page__aside--active');
        resetAccordion();
    };
    [
        ...openFaqBtns
    ].forEach((btn)=>btn.addEventListener('click', openFaq));
    closeFaqBtn.addEventListener('click', ()=>{
        closeFaq();
    });
    const articles = document.querySelector('.faq-module__questions');
    const accordions = document.querySelectorAll('.accordion');
    faqMoreBtn.addEventListener('click', ()=>{
        closeFaq();
    });
    articles.addEventListener('click', (e)=>{
        const article = e.target.closest('article');
        if (!article.classList.contains('accordion--open')) article.classList.add('accordion--open');
        else article.classList.remove('accordion--open');
    });
    document.addEventListener('click', (e)=>{
        const en = e.target;
        if (!faqContent.contains(en)) {
            if (faq.classList.contains('page__aside--active') && [
                ...openFaqBtns
            ].every((btn)=>btn !== en)) closeFaq();
        }
    });
};


const $21bfaf66f257684f$export$cee3e6bbcfb4250e = ()=>{
    const accordions = document.querySelectorAll('.faq__question');
    accordions.forEach((accordion)=>{
        accordion.addEventListener('click', ()=>{
            accordion.classList.toggle('accordion--open');
        });
    });
};


const $f830961d8356cf4f$export$1fba6ea6352fed9 = ()=>{
    const help = document.querySelector('.help-module');
    const helpContent = document.querySelector('.help-module__content');
    const firstHelpList = help.querySelector('.help-module__support');
    const helpServiceBtn = help.querySelectorAll('.help-module__service-btn');
    const closeHelpBtn = document.querySelector('.help-module__close');
    const openHelpBtns = document.querySelectorAll('.help-module-btn');
    const closeHelp = ()=>help?.classList.remove('page__aside--active');
    const openHelp = ()=>help?.classList.add('page__aside--active');
    openHelpBtns.forEach((btn)=>btn.addEventListener('click', openHelp));
    closeHelpBtn.addEventListener('click', closeHelp);
    firstHelpList.addEventListener('click', (e)=>{
        if (e.target.closest('a')) closeHelp();
    });
    helpServiceBtn.forEach((btn)=>btn.addEventListener('click', closeHelp));
    document.addEventListener('click', (e)=>{
        const eventOwner = e.target;
        if (help.classList.contains('page__aside--active')) {
            if (!helpContent.contains(eventOwner) && [
                ...openHelpBtns
            ].every((btn)=>!btn.contains(eventOwner))) closeHelp();
        }
    });
};


const $36696a14613e67a9$export$52dde7f8ceb25d41 = ()=>{
    const TABLET_MIN_WIDTH = 1280;
    let swiper;
    const initSwiper = ()=>{
        swiper = new Swiper('.header__swiper', {
            loop: false,
            grabCursor: true,
            scrollbar: {
                el: '.header__scrollbar',
                draggable: true
            },
            autoplay: {
                delay: 5000
            },
            speed: 600
        });
        const prevBtn = document.querySelector('.header__prev-btn');
        const nextBtn = document.querySelector('.header__next-btn');
        const updateHeaderButtons = ()=>{
            prevBtn.disabled = swiper.isBeginning;
            nextBtn.disabled = swiper.isEnd;
        };
        nextBtn.addEventListener('click', ()=>{
            swiper.slideNext();
        });
        prevBtn.addEventListener('click', ()=>{
            swiper.slidePrev();
        });
        swiper.on('slideChange', updateHeaderButtons);
        swiper.on('scrollbarDragEnd', updateHeaderButtons);
        swiper.on('scrollbarDragMove', updateHeaderButtons);
        updateHeaderButtons();
    };
    const destroySwiper = ()=>{
        if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    };
    const updateSwiperOnResize = ()=>{
        const isSmallScreen = window.innerWidth < TABLET_MIN_WIDTH;
        if (isSmallScreen) destroySwiper();
        else if (!swiper) initSwiper();
    };
    updateSwiperOnResize();
    window.addEventListener('resize', ()=>{
        updateSwiperOnResize();
    });
};


const $6830935b5108d088$export$c04476f7d8efa7eb = ()=>{
    const TABLET_MIN_WIDTH = 1280;
    let aboutSwiper;
    const initSwiper = ()=>{
        aboutSwiper = new Swiper('.about__swiper', {
            loop: false,
            grabCursor: true,
            pagination: {
                el: window.innerWidth < TABLET_MIN_WIDTH ? '.about__bullets' : '.about__fraction',
                type: window.innerWidth < TABLET_MIN_WIDTH ? 'bullets' : 'fraction',
                clickable: true
            },
            scrollbar: {
                el: '.about__scrollbar',
                draggable: true
            },
            spaceBetween: 10
        });
        const prevBtn = document.querySelector('.about__prev-btn');
        const nextBtn = document.querySelector('.about__next-btn');
        const updateAboutButtons = ()=>{
            prevBtn.disabled = aboutSwiper.isBeginning;
            nextBtn.disabled = aboutSwiper.isEnd;
        };
        prevBtn.addEventListener('click', ()=>{
            aboutSwiper.slidePrev();
        });
        nextBtn.addEventListener('click', ()=>{
            aboutSwiper.slideNext();
        });
        aboutSwiper.on('slideChange', updateAboutButtons);
        aboutSwiper.on('scrollbarDragEnd', updateAboutButtons);
        aboutSwiper.on('scrollbarDragMove', updateAboutButtons);
        updateAboutButtons();
    };
    const updateSwiperOnResize = ()=>{
        const isSmallScreen = window.innerWidth < TABLET_MIN_WIDTH;
        if (isSmallScreen && !aboutSwiper.pagination.bullets.length) {
            aboutSwiper.destroy();
            initSwiper();
        } else if (!isSmallScreen && aboutSwiper.pagination.bullets.length) {
            aboutSwiper.destroy();
            initSwiper();
        }
    };
    initSwiper();
    window.addEventListener('resize', ()=>{
        updateSwiperOnResize();
    });
};


const $8475ee83229a32c7$export$8eda6747f5860099 = ()=>{
    const openBars = document.querySelectorAll('.open-bar');
    const openBtns = document.querySelectorAll('.open-bar__circle');
    openBtns.forEach((openBtn)=>{
        openBtn.addEventListener('click', (e)=>{
            e.target.closest('.open-bar').classList.toggle('open-bar--active');
        });
    });
    window.addEventListener('resize', ()=>{
        if (window.innerWidth >= 1280) openBars.forEach((openEl)=>{
            openEl.classList.remove('open-bar--active');
        });
    });
};


const $085912229a405eae$export$f2e532fbf8d84cd0 = ()=>{
    const frm = document.forms['contact__form'];
    const name = frm['name'];
    const nameLabel = document.querySelector('label[for="name"]');
    const nameLabelText = nameLabel.innerText;
    const email = frm['email'];
    const emailLabel = document.querySelector('label[for="email"]');
    const emailLabelText = emailLabel.innerText;
    const phone = frm['phone'];
    const phoneLabel = document.querySelector('label[for="phone"]');
    const phoneLabelText = phoneLabel.innerText;
    const message = frm['message'];
    const messageLabel = document.querySelector('label[for="message"]');
    const messageLabelText = messageLabel.innerText;
    const submitBtn = document.querySelector('.form__button');
    frm.addEventListener('submit', (e)=>{
        e.preventDefault();
        let err = false;
        if (!name.value.trim()) {
            nameField.setError(nameField.msg);
            err = true;
        }
        if (!email.value.trim()) {
            emailField.setError(emailField.msg);
            err = true;
        }
        if (!phone.value.trim()) {
            phoneField.setError(phoneField.msg);
            err = true;
        }
        if (!message.value.trim()) {
            messageField.setError(messageField.msg);
            err = true;
        }
        if (err) return;
        const elements = [
            ...frm.elements
        ];
        elements.forEach((element)=>{
            element.disabled = true;
        });
        const btnText = submitBtn.firstElementChild;
        const btnLoader = submitBtn.lastElementChild;
        const text = btnText.innerText;
        btnText.innerText = '';
        btnLoader.classList.add('form__loader--active');
        wait(2000).then(()=>{
            frm.reset();
        }).finally(()=>{
            elements.forEach((element)=>{
                element.disabled = false;
            });
            btnText.innerText = text;
            btnLoader.classList.remove('form__loader--active');
        });
    });
    function wait(delay) {
        return new Promise((resolve)=>setTimeout(resolve, delay));
    }
    class Field {
        constructor(input, label, labelText, msg){
            this.input = input;
            this.label = label;
            this.labelText = labelText;
            this.errMsg = '';
            this.msg = msg;
        }
        setError(msg) {
            this.label.innerText = msg;
            this.label.style.color = '#860404';
            this.input.style.borderBottomColor = '#860404';
        }
        clearError() {
            this.label.innerText = this.labelText;
            this.label.style.color = '';
            this.input.style.borderBottomColor = '';
        }
    }
    const nameField = new Field(name, nameLabel, nameLabelText, 'Please, fill your name*');
    const emailField = new Field(email, emailLabel, emailLabelText, 'Please, fill your email*');
    const phoneField = new Field(phone, phoneLabel, phoneLabelText, 'Please, fill your phone*');
    const messageField = new Field(message, messageLabel, messageLabelText, 'Please, fill your message*');
    const createHandlers = (field)=>{
        field.input.addEventListener('blur', (e)=>{
            if (!e.target.value.trim()) field.setError(field.msg);
        });
        field.input.addEventListener('input', ()=>{
            field.clearError();
        });
    };
    createHandlers(nameField);
    createHandlers(emailField);
    createHandlers(phoneField);
    createHandlers(messageField);
};


const $68336e7dfa5ab185$export$da8dd052cfb92ddf = ()=>{
    const buy = document.querySelector('.buy-module');
    const firstHelpList = buy.querySelector('.buy-module__support');
    const helpServiceBtn = buy.querySelectorAll('.buy-module__service-btn');
    const closeHelpBtn = document.querySelector('.buy-module__close');
    const openBuyBtns = document.querySelectorAll('.buy-btn');
    const orders = document.querySelectorAll('.buy-module__order');
    const orderBars = document.querySelectorAll('.buy-module__order-bar');
    const steps = document.querySelectorAll('.buy-module__step');
    const nextBtn = document.querySelector('.buy-module__btn');
    const frm = document.forms['contact__form-buy'];
    const homeButton = document.querySelector(".complite__button");
    const payButton = document.querySelector(".pay-order__button");
    const stepPay = document.querySelector(".buy-module__step--pay");
    const stepComplete = document.querySelector(".buy-module__step--complete");
    let currentStep = 0;
    const updateUI = ()=>{
        orders.forEach((order, index)=>{
            order.classList.toggle('buy-module__order--active', index === currentStep);
        });
        orderBars.forEach((orderBar, index)=>{
            orderBar.classList.toggle('buy-module__order-bar--active', index === currentStep);
        });
        steps.forEach((step, index)=>{
            step.classList.toggle('active', index === currentStep);
        });
    };
    const validateForm = ()=>{
        const firstname = frm['firstname'];
        const lastname = frm['lastname'];
        const emailBuy = frm['email-buy'];
        const phoneBuy = frm['phone-buy'];
        const shippingAdress = frm['shipping-adress'];
        const shippingAdress2 = frm['shipping-adress-2'];
        let err = false;
        if (!firstname.value.trim()) {
            firstnameField.setError(firstnameField.msg);
            err = true;
        }
        if (!lastname.value.trim()) {
            lastnameField.setError(lastnameField.msg);
            err = true;
        }
        if (!emailBuy.value.trim()) {
            emailBuyField.setError(emailBuyField.msg);
            err = true;
        }
        if (!phoneBuy.value.trim()) {
            phoneBuyField.setError(phoneBuyField.msg);
            err = true;
        }
        if (!shippingAdress.value.trim()) {
            shippingAdressField.setError(shippingAdressField.msg);
            err = true;
        }
        if (!shippingAdress2.value.trim()) {
            shippingAdress2Field.setError(shippingAdress2Field.msg);
            err = true;
        }
        return !err;
    };
    const handleNextStep = ()=>{
        if (currentStep === 0 && !validateForm()) return;
        if (currentStep < steps.length) {
            currentStep++;
            updateUI();
        } else window.location.href = './index.html';
    };
    nextBtn.addEventListener('click', handleNextStep);
    updateUI();
    payButton.addEventListener("click", ()=>{
        stepPay.classList.remove("active");
        stepComplete.classList.add("active");
        currentStep = steps.length - 1;
        updateUI();
    });
    homeButton.addEventListener("click", ()=>{
        window.location.href = 'index.html';
    });
    // top-bar
    const closeHelp = ()=>buy?.classList.remove('page__aside--active');
    const openHelp = ()=>buy?.classList.add('page__aside--active');
    openBuyBtns.forEach((btn)=>btn.addEventListener('click', openHelp));
    closeHelpBtn.addEventListener('click', closeHelp);
    helpServiceBtn.forEach((btn)=>btn.addEventListener('click', closeHelp));
};


const $ef74320b611f00a8$export$8da78e392d8636b = ()=>{
    const orders = document.querySelectorAll('.buy-module__step');
    const setupQuantity = (orderElement)=>{
        if (!orderElement) return;
        const price = orderElement.querySelector('.order__price-count');
        const qtySelect = orderElement.querySelector('.select-qty');
        const qtySelectValue = qtySelect?.querySelector('.select-qty__current-value');
        const qtySelectList = qtySelect?.querySelector('.select-qty__list-wrapper');
        const qtyItems = Array.from(qtySelectList?.querySelectorAll('.select-qty__item') || []);
        if (!price || !qtySelect || !qtySelectValue || !qtySelectList) return;
        qtySelect.addEventListener('click', ()=>{
            const selectedValue = qtySelectValue.textContent.trim();
            qtyItems.forEach((item)=>{
                item.classList.toggle('hidden', item.textContent === selectedValue);
            });
            qtySelectList.classList.toggle('select-qty__list-wrapper--visible');
        });
        qtySelectList.addEventListener('click', (event)=>{
            const li = event.target.closest('.select-qty__item');
            if (!li || li.classList.contains('hidden')) return;
            const liText = li.textContent.trim();
            qtySelectValue.textContent = liText;
            price.textContent = `${+liText * 1200}$`;
            const selectedLi = qtySelect.querySelector('.select-qty__item--selected');
            selectedLi?.classList.remove('select-qty__item--selected');
            li.classList.add('select-qty__item--selected');
            qtySelectList.classList.remove('select-qty__list-wrapper--visible');
        });
    };
    orders.forEach(setupQuantity);
};


const $9f619d006eabf084$export$973f6b86e329ab0d = ()=>{
    const frm = document.forms['contact__form-buy'];
    const firstname = frm['firstname'];
    const firstnameLabel = document.querySelector('label[for="firstname"]');
    const firstnameLabelText = firstnameLabel.innerText;
    const lastname = frm['lastname'];
    const lastnameLabel = document.querySelector('label[for="lastname"]');
    const lastnameLabelText = lastnameLabel.innerText;
    const emailBuy = frm['email-buy'];
    const emailBuyLabel = document.querySelector('label[for="email-buy"]');
    const emailBuyLabelText = emailBuyLabel.innerText;
    const phoneBuy = frm['phone-buy'];
    const phoneBuyLabel = document.querySelector('label[for="phone-buy"]');
    const phoneBuyLabelText = phoneBuyLabel.innerText;
    const shippingAdress = frm['shipping-adress'];
    const shippingAdressLabel = document.querySelector('label[for="shipping-adress"]');
    const shippingAdressLabelText = shippingAdressLabel.innerText;
    const shippingAdress2 = frm['shipping-adress-2'];
    const shippingAdress2Label = document.querySelector('label[for="shipping-adress-2"]');
    const shippingAdress2LabelText = shippingAdress2Label.innerText;
    const submitBtn = document.querySelector('.form-buy__button');
    frm.addEventListener('submit', (e)=>{
        e.preventDefault();
        let err = false;
        if (!firstname.value.trim()) {
            firstnameField.setError(firstnameField.msg);
            err = true;
        }
        if (!lastname.value.trim()) {
            lastnameField.setError(lastnameField.msg);
            err = true;
        }
        if (!emailBuy.value.trim()) {
            emailBuyField.setError(emailBuyField.msg);
            err = true;
        }
        if (!phoneBuy.value.trim()) {
            phoneBuyField.setError(phoneBuyField.msg);
            err = true;
        }
        if (!shippingAdress.value.trim()) {
            shippingAdressField.setError(shippingAdressField.msg);
            err = true;
        }
        if (!shippingAdress2.value.trim()) {
            shippingAdress2Field.setError(shippingAdress2Field.msg);
            err = true;
        }
        if (err) return;
        const elements = [
            ...frm.elements
        ];
        elements.forEach((element)=>{
            element.disabled = true;
        });
        const btnText = submitBtn.firstElementChild;
        const btnLoader = submitBtn.lastElementChild;
        const text = btnText.innerText;
        btnText.innerText = '';
        btnLoader.classList.add('form-buy__loader--active');
        frm.reset();
        elements.forEach((element)=>{
            element.disabled = false;
        });
        btnText.innerText = text;
        btnLoader.classList.remove('form-buy__loader--active');
    });
    class Field {
        constructor(input, label, labelText, msg){
            this.input = input;
            this.label = label;
            this.labelText = labelText;
            this.errMsg = '';
            this.msg = msg;
        }
        setError(msg) {
            this.label.innerText = msg;
            this.label.style.color = '#860404';
            this.input.style.borderBottomColor = '#860404';
        }
        clearError() {
            this.label.innerText = this.labelText;
            this.label.style.color = '';
            this.input.style.borderBottomColor = '';
        }
    }
    const firstnameField = new Field(firstname, firstnameLabel, firstnameLabelText, 'Please, fill your first name*');
    const lastnameField = new Field(lastname, lastnameLabel, lastnameLabelText, 'Please, fill your last name*');
    const emailBuyField = new Field(emailBuy, emailBuyLabel, emailBuyLabelText, 'Please, fill your email*');
    const phoneBuyField = new Field(phoneBuy, phoneBuyLabel, phoneBuyLabelText, 'Please, fill your phone*');
    const shippingAdressField = new Field(shippingAdress, shippingAdressLabel, shippingAdressLabelText, 'Please, fill your shippingAdress*');
    const shippingAdress2Field = new Field(shippingAdress2, shippingAdress2Label, shippingAdress2LabelText, 'Please, fill your shippingAdress 2*');
    const createHandlers = (field)=>{
        field.input.addEventListener('blur', (e)=>{
            if (!e.target.value.trim()) field.setError(field.msg);
        });
        field.input.addEventListener('input', ()=>{
            field.clearError();
        });
    };
    createHandlers(firstnameField);
    createHandlers(lastnameField);
    createHandlers(emailBuyField);
    createHandlers(phoneBuyField);
    createHandlers(shippingAdressField);
    createHandlers(shippingAdress2Field);
};


'use strict';
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $ff60e7647c4adb6c$export$bfcccf5e317befd3)();
    (0, $689d83c62c3b09ab$export$c28495b2e70485f1)();
    (0, $9463ba52c520f603$export$7120c31117304a49)();
    (0, $2f471956f63bc693$export$5cb4bf18b308e62f)();
    (0, $21bfaf66f257684f$export$cee3e6bbcfb4250e)();
    (0, $f830961d8356cf4f$export$1fba6ea6352fed9)();
    (0, $36696a14613e67a9$export$52dde7f8ceb25d41)();
    (0, $6830935b5108d088$export$c04476f7d8efa7eb)();
    (0, $8475ee83229a32c7$export$8eda6747f5860099)();
    (0, $085912229a405eae$export$f2e532fbf8d84cd0)();
    (0, $68336e7dfa5ab185$export$da8dd052cfb92ddf)();
    (0, $ef74320b611f00a8$export$8da78e392d8636b)();
    (0, $9f619d006eabf084$export$973f6b86e329ab0d)();
});


//# sourceMappingURL=layout_KateVR.d3cc1581.js.map
